/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_A5Inputs */

const en_formatter_faq_a5 = /** @type {(inputs: Formatter_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Standard JSON does not allow comments or trailing commas. Remove them first, then paste valid JSON to format it.`)
};

const ko_formatter_faq_a5 = /** @type {(inputs: Formatter_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아니요. 표준 JSON은 주석이나 후행 쉼표를 허용하지 않습니다. 먼저 제거한 후 유효한 JSON을 붙여넣어 포맷하세요.`)
};

const ja_formatter_faq_a5 = /** @type {(inputs: Formatter_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。標準JSONではコメントや末尾カンマは許可されていません。まず削除してから、有効なJSONを貼り付けてフォーマットしてください。`)
};

/**
* | output |
* | --- |
* | "No. Standard JSON does not allow comments or trailing commas. Remove them first, then paste valid JSON to format it." |
*
* @param {Formatter_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_a5 = /** @type {((inputs?: Formatter_Faq_A5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_A5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_a5(inputs)
	if (locale === "ko") return ko_formatter_faq_a5(inputs)
	return ja_formatter_faq_a5(inputs)
});